import '!./app/core/enumsGen.js';

import './lib/stop-angular-overrides/stop-angular-overrides.js';

import './app/error/FarmnetHttpError.js';
import './app/cfnGlobals.js';
import './app/console.stub.js';
import './app/jsImprovements.js';
import './app/common/underscoreCustom/underscoreExtensions.js';

import './app/localisation/i18n.js';

import './app/init-phase1-moduleinit.js';


import './app/modules/farmnet/base/system/system-config.constant.js';
import './app/common/services/shop.service.js';
import './app/common/components/error-message/error-message.service.js';
import './app/cfnConfig.js';
import './app/cfnRun.js';
import './app/common/events/resize.event.js';
import './app/common/timeZoneHack.js';

import './app/localisation/app.languages.js';

import './app/services.js';
import './app/common/CfnDialogService.js';
import './app/common/loadingBroadcastHint/loadingBroadcastHint.js';
import './app/values.js';
import './app/modules/farmnet/base/system/demoAccountServiceProvider.js';
import './app/routeRedirectService.js';
import './app/filters.js';
import './app/toArrayFilter.js';
import './app/routes.js';

import './lib/seleniumSimulation.js';
import './app/localisation/gridLocalisation.js';
import './app/calendar/calendarService.js';
import './app/genericFarmMap/genericFarmMapService.js';
import './app/genericFarmMap/genericFarmMapController.js';
import './app/system/templatingService.js';

import './app/modules/farmnet/partner.externalAccounts/farmnet.partner.externalAccounts.module.js';
import './app/modules/farmnet/partner.externalAccounts/http/ExternalAccountsHttp.js';
import './app/modules/farmnet/partner.externalAccounts/model/ExternalAccount.js';
import './app/modules/farmnet/partner.externalAccounts/model/ExternalCredentials.js';
import './app/modules/farmnet/partner.externalAccounts/services/ExternalAccounts.js';
import './app/modules/farmnet/partner.externalAccounts/services/ExternalAccountLocale.js';
import './app/modules/farmnet/partner.externalAccounts/ui/SettingsExternalAccountController.js';
import './app/modules/farmnet/partner.externalAccounts/ui/SettingsExternalAccountDirective.js';
import './app/modules/farmnet/partner.externalAccounts/ui/SettingsExternalAccountsController.js';
import './app/modules/farmnet/partner.externalAccounts/ui/SettingsExternalAccountsDirective.js';
import './app/modules/farmnet/partner.fendt/farmnet.partner.fendt.module.js';
import './app/modules/farmnet/partner.fendt/http/FendtVarioDocHttp.js';
import './app/modules/farmnet/partner.fendt/services/FendtVarioDocLocale.js';
import './app/modules/farmnet/partner.fendt/services/FendtVarioDocAlerts.js';
import './app/modules/farmnet/partner.fendt/services/FendtVarioDocService.js';
import './app/modules/farmnet/partner.fendt/ui/FendtVarioDocButtonController.js';
import './app/modules/farmnet/partner.fendt/ui/FendtVarioDocButtonDirective.js';

import './app/modules/farmnet/base.tracking/farmnet.base.tracking.module.js';
import './app/directives/directive-manager.js';
import './app/controllers.js';

import './app/menu/farmController.js';
import './app/menu/cropController.js';
import './app/menu/cattleController.js';
import './app/menu/livestockController.js';

import './app/planning/planning.module.js';
import './app/planning/cropPlanning/cropPlanningChartService.js';
import './app/planning/cropPlanning/cropPlanningData.js';
import './app/planning/cropPlanning/cropPlanningDataResolver.js';
import './app/planning/cropPlanning/cropPlanningOperationController.js';
import './app/planning/cropSequencePlanning/services/cropSequencePlanningService.js';
import './app/planning/cropSequencePlanning/services/greeningService.js';
import './app/planning/cropSequencePlanning/cropSequencePlanningController.js';
import './app/planning/cropSequencePlanning/components/greening/greeningController.js';
import './app/planning/cropSequencePlanning/components/greening/mainCrop/greeningMainCropController.js';
import './app/planning/cropSequencePlanning/components/greening/catchCrop/greeningCatchCropController.js';
import './app/planning/cropSequencePlanning/components/greening/ecologicalFocusArea/ecologicalFocusArea.js';
import './app/planning/cropSequencePlanning/components/greening/ecologicalFocusArea/ecologicalFocusAreaController.js';

import './app/planning/seedPlanning/seedPlanningDataResolver.js';
import './app/planning/seedPlanning/addSeedPopupController.js';
import './app/planning/seedPlanning/seedPlanningModel.js';
import './app/planning/seedPlanning/seedPlanningSummaryModel.js';
import './app/planning/seedPlanning/seedPlanningController.js';

import './app/core/popups/sysSeedCustomPopupController.js';
import './app/core/corePopupListController.js';
import './app/core/popups/popupControllers.js';
import './app/termsAcceptance/termsAcceptanceHttpProxy.js';
import './app/termsAcceptance/termsAcceptanceService.js';
import './app/termsAcceptance/termsAcceptanceController.js';
import './app/core/popups/bookingSupplyPopupController.js';
import './app/core/wizards/bookingImportWizardController.js';
import './app/core/wizards/bookingExportWizardController.js';
import './app/core/wizards/BookingIsoXmlHttp.js';
import './app/core/wizards/BookingIsoXMLConfig.js';
import './app/core/wizards/fieldImportWizardController.js';
import './app/core/wizards/fieldImportWizardService.js';
import './app/booking/directives/variodoc-button.directive.js';
import './app/calendar/calendarHelper.js';
import './app/common/services/navigation.service.ts';
import './app/common/services/notification.service.js';
import './app/common/services/solrService.js';
import './app/modules/farmnet/base/country/countryService.js';
import './app/common/unitConverterService.js';
import './app/common/convertUnit.filter.js';
import './app/common/convertArea.filter.js';
import './app/common/convertPerAreaUnit.filter.js';
import './app/common/unitToString.filter.js';
import './app/common/journalRenderService.js';
import './app/common/transition-helper.service.js';
import './app/common/dataSource.factory.js';
import './app/common/search.service.js';
import './app/core/assets/Field.js';
import './app/core/assets/fieldCoreController.js';
import './app/core/assets/fieldCoreDataResolver.js';
import './app/core/assets/fieldCoreCustom.js';
import './app/core/assets/fieldGroupCoreController.js';
import './app/core/assets/fieldGroupCoreDataResolver.js';
import './app/core/assets/FieldGroup.js';
import './app/core/assets/Stockyard.js';
import './app/core/assets/stockyardCoreDataResolver.js';
import './app/core/assets/stockyardCoreController.js';
import './app/core/supplies/plantProtectantModuleConnectorProvider.js';
import './app/core/supplies/plantProtectantCoreCustom.js';
import './app/core/supplies/seed-properties.directive.js';
import './app/core/supplies/fertilizerCoreCustom.js';
import './app/core/supplies/seedCoreCustom.js';
import './app/core/supplies/Fertilizer.js';
import './app/core/supplies/fertilizerCoreDataResolver.js';
import './app/core/supplies/fertilizerCoreController.js';
import './app/core/supplies/PlantProtectant.js';
import './app/core/supplies/plantProtectantCoreDataResolver.js';
import './app/core/supplies/plantProtectantCoreController.js';
import './app/core/supplies/Seed.js';
import './app/core/supplies/seedCoreDataResolver.js';
import './app/core/supplies/seedCoreController.js';
import './app/core/supplies/CropSequence.js';
import './app/core/supplies/cropSequenceCoreDataResolver.js';
import './app/core/supplies/cropSequenceCoreController.js';
import './app/core/resources/personCoreCustom.js';
import './app/core/popups/allItemsPopupController.js';
import './app/core/coreCommonController.js';
import './app/core/coreUnitService.js';
import './app/genericFarmMap/genericFarmMapElement.directive.js';
import './app/core/resources/Person.js';
import './app/core/resources/personCoreController.js';
import './app/core/resources/personCoreDataResolver.js';
import './app/core/resources/PersonGroup.js';
import './app/core/resources/personGroupCoreController.js';
import './app/core/resources/personGroupCoreDataResolver.js';

import './app/directives/cfnPageInfo.js';
import './app/directives/cfnPageButtons.js';
import './app/directives/cfnGrid/cfnGridDefaults.js';
import './app/directives/cfnGrid/cfnGridHelpers.js';
import './app/directives/cfnGrid/cfnGridCompatibility.js';
import './app/directives/cfnGrid/cfnGridDynamicColumn.js';
import './app/directives/cfnGrid/cfnGridHacks.js';
import './app/directives/cfnGrid/cfnGridFnHacks.js';
import './app/directives/cfnGrid/cfnGridEvents.js';
import './app/directives/cfnGrid/cfnGridSelection.js';
import './app/directives/cfnGrid/cfnGridFiltering.js';
import './app/directives/cfnGrid/cfnGridRenderer.js';
import './app/directives/cfnGrid/cfnGridSorting.js';
import './app/directives/cfnGrid/cfnGridSizing.js';
import './app/directives/cfnGrid/cfnGridPrinting.js';
import './app/directives/cfnGrid/cfnGridModel.js';
import './app/directives/cfnGrid/cfnGridView.js';
import './app/directives/cfnGrid/cfnGridTemplates.js';
import './app/directives/cfnGrid/cfnGridController.js';
import './app/directives/cfnGrid/cfnGrid.js';

import './app/booking/templates/cfnBookingElement.js';
import './app/directives/cfnPageRight.js';
import './app/directives/cfnPrint.js';
import './app/directives/cfnSpinner.js';
import './app/directives/cfnCollapse.js';
import './app/directives/wizard-helpers.directives.js';
import './app/directives/cfn-vendor-product-id.directive.js';
import './app/directives/table.directive.js';
import './app/directives/cfn-fixed-col.directive.js';
import './app/directives/cfnInfluencesPayment.directive.js';
import './app/directives/dRemoveIfNoModule.js';
import './app/directives/core/cfn-core-crop-sequence-display.directive.js';
import './app/directives/core/cfn-costs-form.directive.js';
import './app/directives/import/cfn-import-lifecycle.directive.js';
import './app/directives/import/cfn-import-soil-history-tab.directive.js';
import './app/common/services/requiresProductLicensePopup.service.js';
import './app/common/directives/d-requires-product-license.directive.js';

import './app/directives/input/select.directives.js';
import './app/directives/input/reference/cfn-multi-reference-box.js';
import './app/directives/input/reference/cfn-reference-box.js';
import './app/directives/input/reference/cfn-reference-box-multi.js';
import './app/directives/input/reference/cfn-select-multi-reference.js';
import './app/directives/input/reference/cfn-select-reference.js';
import './app/directives/input/reference/cfn-tag-list-reference-box.js';
import './app/directives/input/autocomplete.directive.js';
import './app/directives/input/btn-toggle.directive.js';
import './app/directives/input/slider.directive.js';
import './app/directives/input/text-and-numbers.directives.js';
import './app/directives/input/validate-email.directive.js';
import './app/directives/input/cfn-numeric.directive.js';

import './app/directives/input/time-and-date/cfn-input-date.directive.js';
import './app/directives/input/time-and-date/cfn-input-datedaymonth.directive.js';
import './app/directives/input/time-and-date/cfn-input-dateperiod.directive.js';
import './app/directives/input/time-and-date/cfn-input-date-picker.directive.js';
import './app/directives/input/time-and-date/cfn-input-datetime.directive.js';
import './app/directives/input/time-and-date/cfn-input-time.directive.js';
import './app/directives/input/time-and-date/cfn-input-time-value.directive.js';
import './app/directives/input/time-and-date/d-date-filter.directive.js';

import './app/directives/input/time-and-date/cfn-input-timeduration.directive.js';
import './app/directives/input/time-and-date/cfn-input-timepicker.directive.js';
import './app/directives/input/time-and-date/time-formatter.service.js';

import './app/directives/personal-data/personal-data.directives.js';

import './app/directives/plant/plant.directives.js';
import './app/directives/plant/cfn-display-table.directives.js';

import './app/directives/stock/cfn-stock-fill-display.directive.js';

import './app/directives/appIcon/appIcon.js';
import './app/directives/demo-account/demo-account.directives.js';

import './app/common/chart/pie/pieChart.js';
import './app/common/directives/d-limit-to-country.directive.js';
import './app/common/directives/d-hide-in-country.directive.js';
import './app/common/directives/d-sticky-nav.directive';
import './app/common/directives/d-loading.directive.js';
import './app/common/directives/highcharts-wrapper.directive.js';
import './app/common/directives/d-this-view-requires.directive.js';
import './app/common/directives/inputDecimal.js';
import './app/common/directives/d-tristate.directive.js';
import './app/common/services/frontend-filter/array-item-key-filter.service.js';
import './app/common/services/frontend-filter/frontend-filter.service.js';
import './app/common/components/confirm-modal-persistent/confirm-modal-persistent.controller.js';
import './app/common/components/confirm-modal-persistent/confirm-modal-persistent.service.js';
import './app/common/components/email-change-confirm-popup/email-change-confirm-popup.directive.js';
import './app/common/components/email-change-confirm-popup/email-change-confirm-popup.controller.js';
import './app/common/directives/d-page-button-dropdown/d-page-button-dropdown.directive.js';
import './app/common/directives/d-grid-data.js';
import './app/common/directives/d-tabs/d-tab-container/d-tab-container.js';
import './app/common/directives/d-tabs/d-tab/d-tab.js';
import './app/common/directives/d-tabs/d-tab-with-count/d-tab-with-count.js';
import './app/common/directives/d-tabs/d-tab-content/d-tab-content.js';
import './app/common/directives/number-input.directive.js';

import './app/factories/presentationModelFactory.js';
import './app/factories/autoSaveServiceFactory.js';
import './common/fix_parseBackendDate.js';
import './app/analyse/analyseService.js';

import './app/analyse/stockService.js';
import './app/analyse/stockReportController.js';

import './app/analyse/cropOverviewControllerResolver.js';
import './app/analyse/cropOverviewController.js';

import './gea/modules.js';
import './app/partner/amazone/amazoneMachineSettingsButtonDirective.js';
import './app/partner/amazone/amazoneMachineSettingsDirective.js';
import './app/partner/amazone/amazoneMachineService.js';
import './app/partner/amazone/amazoneMachineSettingsPopupController.js';
import './app/admin/settings/userSettingsService.js';
import './app/admin/settings/userSettingsModelFilter.js';

import './app/admin/settings/settingsResource.js';
import './app/admin/settings/user/userSettingsResource.js';
import './app/admin/settings/user/userSettingsController.js';
import './app/admin/settings/user/changeEmailService.js';
import './app/admin/settings/user/newsletterSubscriptionService.js';
import './app/admin/adminController.js';
// CFNPOC-48729
// import './app/admin/ticket/Ticket.js';
// import './app/admin/ticket/ticketControllerDataResolver.js';
// import './app/admin/ticket/ticketController.js';
import './app/admin/settings/company/companySettingsController.js';
import './app/admin/settings/company/genericModalDirective.js';
import './app/admin/settings/company/companySettingsResource.js';
import './app/admin/settings/external/plant/settingsPlantController.js';
import './app/core/company/companyFinanceService.js';
import './app/core/farm/farmService.js';
import './app/core/supplies/fertiwebCodeService.js';

import './app/shop/shop.validation.service.js';
// import './app/shop/ShopProductService.js';
import './lib/l10nservice/converter/Default.js';
import './lib/l10nservice/converter/Flavours.js';
import './lib/l10nservice/converter/Lookup.js';
import './lib/l10nservice/converter/Units.js';
import './lib/l10nservice/UnitConverter.js';
import './app/dashboard/alertsDirective.js';
import './app/dashboard/dashboardController.js';
import './app/dashboard/dashboard-selector.js';
import './app/booking/bookingActivitiesService.js';
import './app/booking/bookingImportWizardService.js';
import './app/booking/ownActivities/ownActivitiesIconsDirective.js';
import './app/booking/bookingListController.js';
import './app/booking/bookingMaskController.js';
import './app/booking/bookingMaskService.js';
import './app/booking/bookingMaskDataResolver.js';
import './app/booking/templates/fieldTable.js';
import './app/booking/templates/fruitTable.js';
import './app/booking/templates/personTable.js';
import './app/booking/templates/machineTable.js';
import './app/booking/templates/seedTable.js';
import './app/booking/templates/cfnBookingSupply.js';
import './app/booking/templates/sysCultureTable.js';
import './app/booking/templates/sysCultureTableService.js';
import './app/booking/templates/soilSampleTable.js';
import './app/booking/templates/stockyardTable.js';
import './app/booking/stockyardListController.js';
import './app/booking/stockyardMaskController.js';
import './app/booking/templates/partnerTable.js';
import './app/booking/templates/notesTables.js';
import './app/booking/templates/attachmentsTables.js';
import './app/booking/bookingMaskArguments.js';
import './app/booking/bookingRules.js';
import './app/booking/bookingOperations.js';
import './app/booking/bookingService.js';
import './app/booking/bookingRenderService.js';
import './app/booking/bookingDate/bookingDateDirective.js';
import './app/booking/bookingActivitiesPopupController.js';
import './app/booking/bookingNavigationService.js';
import './app/booking/bookingAttachmentService.js';
import './app/calendar/calendarController.js';
import './app/calendar/calendarPopupController.js';
import './app/calendar/calendarFilterPopupController.js';
import './app/landing/landsbergController.js';

import './app/credentials/cfnCredentialsCompany.js';
import './app/common/seedSearch.service.js';
import './app/common/cultureSearch.service.js';
import './app/common/harvestBooking.service.js';
import './app/common/fieldSearch.service.js';
import './app/common/seedSuggestion.service.js';


import './monolith-env.js';

// google maps api key for 'prod'
